export default "__VITE_ASSET__Ctc$Dbgc__"